import { render } from "./SelectPromoCode.vue?vue&type=template&id=3b8a29ef&scoped=true"
import script from "./SelectPromoCode.vue?vue&type=script&lang=js"
export * from "./SelectPromoCode.vue?vue&type=script&lang=js"

import "./SelectPromoCode.vue?vue&type=style&index=0&id=3b8a29ef&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8a29ef"]])

export default __exports__